export const VIEWS = {
  TABLE: 'Table',
  CHART: 'Chart',
} as const;

export const Constants = {
  TAG_NAME: 'pop-credit-quality-component',
  COMPONENT_TITLE: 'Credit Quality',
  DATA_AS_OF_DROPDOWN_LABEL: 'Data as of',
  DATA_AS_OF_DROPDOWN_ID: 'credit-quality-data-as-of-select',
  VIEW_DROPDOWN_LABEL: 'View',
  VIEW_DROPDOWN_ID: 'credit-quality-view-select',
  VIEWS: [VIEWS.TABLE, VIEWS.CHART],
  DEFAULT_VIEW: VIEWS.CHART,
  BENCHMARK_PREFIX: 'Benchmark:',
  CREDIT_QUALITY_UNAVAILABLE: 'Credit quality unavailable',
} as const;
